<template>
  <v-container fluid class="pa-5">
    <!-- Header -->
    <v-sheet class="pa-4 mb-4" color="#194c9b" elevation="2" rounded>
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div class="d-flex align-center ga-3">
          <v-icon color="white">mdi-account-group</v-icon>
          <div class="text-h5 text-white font-weight-bold">
            {{ $t("titulo_adm_equipo") }}
          </div>
        </div>
      </div>
    </v-sheet>

    <!-- TABS -->
    <v-card elevation="2" rounded="lg">
      <v-tabs v-model="tab" bg-color="transparent" color="primary" class="px-2">
        <v-tab value="equipos">
          <v-icon start>mdi-database</v-icon>
          {{ $t("Equipos") }}
        </v-tab>
        <v-tab value="proyecto">
          <v-icon start>mdi-link</v-icon>
          {{ $t("asign_a_proyectos") }}
        </v-tab>
        <v-tab value="miembros">
          <v-icon start>mdi-account-multiple-plus</v-icon>
          {{ $t("miembros_to_team") }}
        </v-tab>
      </v-tabs>

      <v-divider />

      <v-window v-model="tab">
        <v-window-item value="equipos">
          <TabEquipos
            ref="tabEquiposRef"
            :api-base="API_BASE"
            :toast="toast"
            @goMembers="goMembers"
          />
        </v-window-item>

        <v-window-item value="proyecto">
          <TabAsignacionProyecto
            :api-base="API_BASE"
            :toast="toast"
            @refresh-equipos="refreshEquiposTable"
          />
        </v-window-item>

        <v-window-item value="miembros">
          <TabMiembrosEquipo
            :api-base="API_BASE"
            :toast="toast"
            :prefill-team-id="membersPrefillTeamId"
            @clearPrefill="membersPrefillTeamId = null"
          />
        </v-window-item>
      </v-window>
    </v-card>

    <!-- Snackbar global -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="2800">
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import TabEquipos from "./componentes/TabEquipos.vue";
import TabAsignacionProyecto from "./componentes/TabAsignacionProyecto.vue";
import TabMiembrosEquipo from "./componentes/TabMiembrosEquipo.vue";

export default {
  name: "EquiposProyecto",
  components: { TabEquipos, TabAsignacionProyecto, TabMiembrosEquipo },

  data() {
    return {
      API_BASE: "http://127.0.0.1:8005/login",
      tab: "equipos",
      membersPrefillTeamId: null,
      snackbar: { show: false, text: "", color: "success" },
    };
  },

  methods: {
    toast(text, color = "success") {
      this.snackbar = { show: true, text, color };
    },

    goMembers(teamId) {
      this.membersPrefillTeamId = teamId ?? null;
      this.tab = "miembros";
    },
    async refreshEquiposTable() {
      await this.$refs.tabEquiposRef?.buildTeamToProjectMap();
    },
  },
};
</script>

<style scoped>
.ga-3 {
  gap: 12px;
}
.ga-2 {
  gap: 8px;
}
</style>
